<template>
    <div>
        <div class="columns" v-if="tag !== null">
            <div class="column is-6">
                <tag-form :tag="tag" @saved="reloadTag"></tag-form>
            </div>
            <div class="column is-6">
                <h2 class="subtitle">Products with this tag</h2>
                <div v-for="product in linkedProducts">
                    <router-link :to="{ name: 'product', params: {id: product.id}}">
                        {{ product.name }}
                    </router-link>
                </div>
                <br/>
                <a>Add tag to product...</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    export default {
        data() {
            return {
                tag_id: parseInt(this.$route.params.id),
                tag: null,
            }
        },
        computed: Object.assign({}, mapGetters(['tags', 'products']), {
            linkedProducts() {
                let links = this.$store.state.products.product_tags.filter(item => item.tag_id === this.tag_id)
                let ids   = []
                for (let link in links) {
                    ids.push(links[link].product_id)
                }

                return this.products.filter(product => ids.indexOf(product.id) !== -1)
            },
        }),
        mounted() {
            this.reloadTag();
        },
        methods: {
            changeTag(newId, oldId) {
                this.tag_id = parseInt(newId)
                this.reloadTag()
            },
            reloadTag() {
                this.tag = null;
                setTimeout(() => {
                    this.tag = this.tags.find(category => category.id === this.tag_id)
                })
            }
        },
        watch: {
            '$route.params.id': 'changeTag'
        }
    };
</script>



// WEBPACK FOOTER //
// TagEdit.vue?1dde3bba